import React from 'react';
import { Head } from 'react-static';

export default ({ image }) => {
  const title = 'Supplemental Notice of Insurance Information Practices | Northwestern Mutual';
  const description = 'View our Online Privacy Notices.';
  const url = 'https://www.northwesternmutual.com/supplemental-notice-of-insurance-information-practices/';
  const publisher = 'Northwestern Mutual';
  const imageAlt = 'Northwestern Mutual logo';
  const imageAbsolutePath = `https://www.northwesternmutual.com${image}`;

  return (
    <Head>
      <meta name='addsearch-category' content='Planning' />
      <meta name='keywords' content='supplemental notice of insurance information practices, Supplemental Notice of Insurance Information Practices' />
      <meta name="author" content={publisher} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={publisher} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:site" content="@NM_Financial" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:creator" content="@NM_Financial" />
      <meta name="twitter:creator:id" content="@NM_Financial" />
      <meta name="twitter:image" content={imageAbsolutePath} />
      <meta name="twitter:image:alt" content={imageAlt} />
      <meta name="twitter:card" content="summary_large_image" />

      <script type='application/ld+json'>
        {`{
          "@context": "https://schema.org",
          "@type": "DigitalDocument",
          "name": "Supplemental Notice of Insurance Information Practices",
          "dateModified": "2024-02-09"
        }`}
      </script>

    </Head>
  );
};
